import { Box, BoxProps } from '@wrisk/ui-components'
import { isNil } from 'lodash-es'
import React, { FunctionComponent } from 'react'

import {
  toVehicleEngine,
  toVehicleEnginePowerVIN,
  toVehicleFuelDescriptionVIN,
  VehicleVIN,
} from '../../../../../domain'
import {
  tEntries,
  tFormats,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { VehicleRow } from './VehicleRow'

interface VehicleDetailsProps extends BoxProps {
  vehicle: VehicleVIN
}

export const VehicleDetails: FunctionComponent<VehicleDetailsProps> = ({
  vehicle,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const imported = isNil(vehicle.imported)
    ? undefined
    : vehicle.imported
    ? t(tEntries('boolean.yes'))
    : t(tEntries('boolean.no'))

  const grossWeight = isNil(vehicle.grossWeight)
    ? undefined
    : t(tFormats('number.standard'), {
        amount: vehicle.grossWeight,
      })

  return (
    <Box width={1} {...props}>
      <VehicleRow name='Manufactured' value={vehicle.year.toString()} />
      <VehicleRow name='Fuel' value={toVehicleFuelDescriptionVIN(vehicle)} />
      <VehicleRow name='Electric type' value={vehicle.electricVehicleType} />
      <VehicleRow name='Body style' value={vehicle.bodyStyle} />
      <VehicleRow name='Transmission' value={vehicle.transmission} />
      <VehicleRow name='Drive train' value={vehicle.driveTrain} />
      <VehicleRow name='Engine' value={toVehicleEngine(vehicle)} />
      <VehicleRow name='Performance' value={toVehicleEnginePowerVIN(vehicle)} />
      <VehicleRow name='Imported' value={imported} />
      <VehicleRow name='Gross weight' value={grossWeight} />
    </Box>
  )
}
